import React, { useMemo, useState } from "react";

type Props = {
  label: string;
  value: string;
  onChange: (val: string) => void;
  minLength?: number;
  subLabel?: string;
  error?: string;
  isEditable?: boolean;
  id?: string;
};

const PasswordInput: React.FC<Props> = ({
  label,
  value,
  onChange,
  minLength,
  subLabel,
  error,
  isEditable = true,
  id,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputId = useMemo(
    () => id || `onb-password-${label.replace(/\s+/g, "-").toLowerCase()}-${Math.random().toString(36).slice(2, 8)}`,
    [id, label]
  );
  const helpId = `${inputId}-help`;
  const errorId = `${inputId}-error`;

  const describedBy = [subLabel ? helpId : null, error ? errorId : null]
    .filter(Boolean)
    .join(" ");

  const type = showPassword ? "text" : "password";

  return (
    <div className="form-group">
      <div>
        <label htmlFor={inputId} className="col-form-label required">
          {label}
        </label>

        {subLabel && (
          <small id={helpId} className="form-text text-muted d-block">
            {subLabel}
          </small>
          )}
      </div>

      <div className="input-group flex-nowrap">
        <input
          id={inputId}
          type={type}
          className={`form-control flex-fill ${error ? "is-invalid" : ""}`}
          value={value}
          minLength={minLength}
          onChange={(e) => onChange(e.target.value)}
          readOnly={!isEditable}
          aria-invalid={!!error}
          aria-describedby={describedBy || undefined}
        />
        <div className="input-group-append">
          <button
            type="button"
            className="btn"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            aria-pressed={showPassword}
            aria-controls={inputId}
            title={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <i className="far fa-eye-slash" aria-hidden="true"></i>
            ) : (
              <i className="far fa-eye" aria-hidden="true"></i>
            )}
          </button>
        </div>
      </div>

      {error && (
        <div id={errorId} className="text-danger">
          {error}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
